<template>
  <div id="e3">

    <v-card max-width="700" style="border-radius: 30px;">
      <v-container
          fluid
          grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12 sm12 md4 lg4>
            <v-flex xs12 sm12 md12 lg12 style="display: flex; justify-content: space-around; flex-direction: column;
    flex-wrap: wrap; align-items: center;">
              <v-flex xs12 sm12 md12 lg12>
                <v-avatar size="75" style="margin-top: 45px;">
                  <img
                      src="https://cdn.vuetifyjs.com/images/john.jpg"
                      alt="John"
                  >
                </v-avatar>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12>
                <p style="margin-top: 20px;">{{ yatrikar_activity.shared_by.first_name }} {{" "}} {{
                    yatrikar_activity.shared_by.last_name }}</p>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12>
                <v-btn color="" style="border-radius: 5px;">{{ moment(yatrikar_activity.created_at).format("ddd, Do MMM YYYY")
                  }}</v-btn>
                </v-flex>
              <v-flex xs12 sm12 md12 lg12 v-if="this.$vuetify.breakpoint.name == 'sm'" style="display: flex;">
                <v-flex xs6 sm6>
                  <v-btn medium color="green" @click="status1 = 1, updateStatus()" :loading="approveLoader"
                                       :disabled="approveLoader || yatrikar_activity.status == 1 ||
                                       yatrikar_activity.status == 2"
                                       style="border-radius: 5px;">
                  Approve
                  <v-icon class="material-icons" color="white" dark style="width: 36px; padding-left: 8px;">
                    thumb_up_alt</v-icon>
                </v-btn>
                </v-flex>
                <v-flex xs6 sm6>
                  <v-btn medium color="red" @click="status1 = 2, updateStatus()"
                         :loading="rejectLoader"
                         :disabled="rejectLoader || yatrikar_activity.status == 1
                || yatrikar_activity.status == 2" style="border-radius: 5px;">
                    Reject
                    <v-icon class="material-icons" color="white" dark style="width: 50px; padding-left: 10px;">
                      thumb_down_alt</v-icon>
                  </v-btn>
                </v-flex>
              </v-flex>


              <v-flex xs12 sm12 md12 lg12 v-if="this.$vuetify.breakpoint.name == 'lg' ||
              this.$vuetify.breakpoint.name == 'md' ||
              this.$vuetify.breakpoint.name == 'xs'">
                <v-btn large color="green" @click="status1 = 1, updateStatus(),
                  approveLoader = true" :loading="approveLoader"
                       :disabled="approveLoader || yatrikar_activity.status == 1 || yatrikar_activity.status == 2"
                       style="border-radius: 5px;">
                  Approve
                  <v-icon class="material-icons" color="white" dark style="width: 36px; padding-left: 8px;">
                    thumb_up_alt</v-icon>
                </v-btn>
              </v-flex>

              <v-flex xs12 sm12 md12 lg12 v-if="this.$vuetify.breakpoint.name == 'lg' ||
              this.$vuetify.breakpoint.name == 'md' ||
              this.$vuetify.breakpoint.name == 'xs'">
                <v-btn large color="red" @click="status1 = 2, updateStatus()"
                       :loading="rejectLoader"
                       :disabled="rejectLoader || yatrikar_activity.status == 1
                || yatrikar_activity.status == 2" style="border-radius: 5px;">
                  Reject
                  <v-icon class="material-icons" color="white" dark style="width: 50px; padding-left: 10px;">
                    thumb_down_alt</v-icon>
                </v-btn>
              </v-flex>

            </v-flex>
          </v-flex>
          <v-flex xs12 sm12 md1 lg1>
            <v-divider vertical
                       v-if="this.$vuetify.breakpoint.name == 'lg' || this.$vuetify.breakpoint.name == 'md'"></v-divider>

            <v-divider v-else></v-divider>

          </v-flex>

          <v-flex xs12 sm12 md7 lg7>
            <v-flex xs12 sm12 md12 lg12>
              <v-img
                  :src="yatrikar_activity.image_url != null ? storage_path()+'yatrikar_activities/'+ yatrikar_activity.image_url :
       '/images/default_user.png'"
                  height="200px" style="margin: auto; border-radius: 10px;"
              >
                <v-container
                    fill-height
                    fluid
                    pa-2
                >
                </v-container>
              </v-img>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12>
              <v-card style="background-color: lightgray; border-radius: 10px;">
                <v-card-text>{{yatrikar_activity.description}}</v-card-text>
              </v-card>

            </v-flex>
          </v-flex>

        </v-layout>
      </v-container>
    </v-card>


    <v-snackbar v-model="snackbar.display" :color="snackbar.color" :top="snackbar.top" :bottom="snackbar.bottom"
                :left="snackbar.left" :right="snackbar.right" :timeout="snackbar.timeout">
      {{ snackbar.message }}
      <v-btn
          text
          dark
          @click="snackbar.display = false"
      >
        <v-icon
            right
            color="white"
        >
          close
        </v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "Details",
  data() {
    return {
      yatrikar_activity: [],
      snackbar: {
        message: '',
        display: false,
        color: 'black',
        top: true,
        right: true,
        bottom: false,
        left: false,
        timeout: 2000
      },
      approveLoader: false,
      rejectLoader: false,
      status1: 0,
    }
  },
  methods: {
    getYatrikarSharingDetails() {
      this.loader = true;
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/show-yatrikar-details/` + this.$route.params.id, {
            params: this.pagination,
            headers: this.$headers,
          })
          .then((response) => {
            if (response.data.status == 1) {
              this.loader = false;
              this.yatrikar_activity = response.data.data;
            } else if (response.data.status == 0) {
              this.loader = false;
              this.snackbar.message = response.data.message;
              this.snackbar.display = true;
            }
          })
          .catch((error) => {
            console.log(error);
            this.loader = false;
            this.snackbar.message = "Something went wrong";
            this.snackbar.display = true;
          })
    },
    updateStatus(){
      if(this.status1 == 1){
        this.approveLoader = true;
      }else if(this.status1 == 2){
        this.rejectLoader = true;
      }
      axios
          .post(`${process.env.VUE_APP_API_URL}/api/v1/update-activity-status` , {
            id: this.$route.params.id, status: this.status1}, {headers: this.$headers,})
          .then((response) => {
            if (response.data.status == 1) {
              this.approveLoader = false;
              this.rejectLoader = false;
              this.yatrikar_activity = response.data.data;
              this.$router.push({ name: 'yatrikarMoments', params:{ message: response.data.message}})

            } else if (response.data.status == 0) {
              this.approveLoader = false;
              this.rejectLoader = false;
              this.snackbar.message = response.data.message;
              this.snackbar.display = true;
            }
          })
          .catch((error) => {
            console.log(error);
            this.approveLoader = false;
            this.rejectLoader = false;
            this.snackbar.message = "Something went wrong";
            this.snackbar.display = true;
          }).finally(() => {
        this.approveLoader = false;
        this.rejectLoader = false;
      });
    }
  },
  mounted() {
    this.getYatrikarSharingDetails();
  }
}
</script>

<style scoped>

</style>
